/* eslint-disable */
import React from 'react'
import styled from '@emotion/styled'
import classNames from 'classnames'
import { useConfig } from '@peracto/peracto-config'
import { SIDE_BY_SIDE_FROM, resolveSideBySideFrom } from '../sideBySideFrom'

const ComponentWrapper = styled.div`
    position: relative;
    /* this padding property is ignored if theres aspect ratio set */
    padding: ${(props) => (props.aspectRatio ? null : props.isPreviewMode ? '0px' : '0.625em')};

    max-width: 100%;

    padding-bottom: ${(props) =>
        props.aspectRatio
            ? () => {
                  switch (props.aspectRatio) {
                      case '4:3':
                          return '75%'
                      default:
                          return '100%'
                  }
              }
            : props.isPreviewMode
              ? '0px'
              : '0.625em'};

    @media all and (min-width: ${(props) => props?.screens?.sm || '576px'}) {
        padding-bottom: ${(props) =>
            props.aspectRatio
                ? () => {
                      switch (props.aspectRatio) {
                          case '4:3':
                              return '75%'
                          case '16:9':
                              return '56.25%'
                          case '2:1':
                              return '50%'
                          default:
                              return '100%'
                      }
                  }
                : props.isPreviewMode
                  ? '0px'
                  : '0.625em'};
    }

    @media all and (min-width: ${(props) => props?.screens?.md || '768px'}) {
        width: 100%;
    }

    @media all and (min-width: ${(props) => props?.screens?.lg || '992px'}) {
        width: 100%;
    }

    @media all and (min-width: ${(props) => props?.screens?.xl || '1210px'}) {
        max-width: ${(props) => {
            switch (props.container) {
                case 'standard':
                    return `${props?.screens?.xl || '1210px'}`
            }
        }};
    }

    margin-left: ${(props) => (props.container !== 'full' ? 'auto' : '0')};
    margin-right: ${(props) => (props.container !== 'full' ? 'auto' : '0')};

    > div {
        ${(props) =>
            props.aspectRatio
                ? `position: absolute;
                    top: 0;
                    left; 0;
                    width: 100%;
                    height: 100%;`
                : null};

        display: ${(props) => (props.aspectRatio ? 'flex' : 'static')};
        justify-content: center;
        align-items: ${(props) => props.alignContent};

        &.side-by-side-from-always,
        &.mobile-two-col-layout {
            // Ory's grid's 'sm' breakpoint starts at 768px.
            // We have to use max-width here because otherwise it'll override the grid layout on
            // 'sm' and up due to the increased specificity.
            @media all and (max-width: 767px) {
                .ory-cell-xs-12 {
                    width: 50%;
                    min-width: 50%;
                    flex-basis: 50%;

                    .ory-cell-xs-12 {
                        width: 100%;
                        min-width: 100%;
                        flex-basis: 100%;
                    }
                }
            }
        }

        &.side-by-side-from-mobile {
            // Stack below Tailwind sm (576px). Ory still stacks until 768px, so force
            // side-by-side between 576px and 767px.
            @media all and (min-width: 576px) and (max-width: 767px) {
                .ory-cell-xs-12 {
                    width: 50%;
                    min-width: 50%;
                    flex-basis: 50%;

                    .ory-cell-xs-12 {
                        width: 100%;
                        min-width: 100%;
                        flex-basis: 100%;
                    }
                }
            }
        }

        &.side-by-side-from-desktop {
            // Stack below Tailwind lg (992px). Ory's 'sm' applies from 768px.
            // Use @media (not @container) — emotion mangles nested @container rules.
            // !important beats Ory's .ory-cell-sm-* rules.
            // Force stretch so Vertically Align Content: Centre doesn't shrink-wrap cells.
            @media all and (max-width: 991px) {
                .ory-dimensions > .ory-row-droppable-container > .ory-row,
                .ory-dimensions > .ory-row-droppable > .ory-row,
                > .ory-row {
                    align-items: stretch !important;
                    flex-wrap: wrap !important;
                }

                .ory-dimensions > .ory-row-droppable-container > .ory-row > .ory-cell,
                .ory-dimensions > .ory-row-droppable > .ory-row > .ory-cell,
                > .ory-row > .ory-cell {
                    width: 100% !important;
                    min-width: 100% !important;
                    max-width: 100% !important;
                    flex: 0 0 100% !important;
                    flex-basis: 100% !important;
                }
            }
        }

        &.container__match-height {
            > .ory-row,
            > .ory-dimensions > .ory-row-droppable-container > .ory-row {
                align-items: stretch !important;

                .ory-cell-inner > .ory-cell *:not([class*='content__']):not([class*='content__'] *) {
                    display: flex;
                    height: 100%;
                    flex-direction: column;
                    max-width: 100%;
                }

                .content__text {
                    margin: 0 !important;
                }
            }

            .ory-cell-inner {
                width: 100%;
            }
        }

        &.container__align-content--top {
            > .ory-row,
            > .ory-dimensions > .ory-row-droppable-container > .ory-row {
                align-items: flex-start;
            }
        }

        &.container__align-content--center {
            > .ory-row,
            > .ory-dimensions > .ory-row-droppable-container > .ory-row {
                align-items: center;
            }
        }

        &.container__align-content--end {
            > .ory-row,
            > .ory-dimensions > .ory-row-droppable-container > .ory-row {
                align-items: flex-end;
            }
        }

        &.container__justify-content--center {
            > .ory-row,
            > .ory-dimensions > .ory-row-droppable-container > .ory-row,
            > .ory-dimensions > .ory-row-droppable > .ory-row {
                justify-content: center;

                .ory-cell-inner.ory-cell-leaf {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            }
        }

        &.container__justify-content--end {
            > .ory-row,
            > .ory-dimensions > .ory-row-droppable-container > .ory-row,
            > .ory-dimensions > .ory-row-droppable > .ory-row {
                justify-content: flex-end;

                .ory-cell-inner.ory-cell-leaf {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                }
            }
        }
    }
`

const Component = (props = {}) => {
    const {
        state = {},
        children,
        isPreviewMode,
    } = props

    const {
        containerSize = 'full',
        containerType = 'fluid',
        aspectRatio = '',
        alignContent = 'flex-start',
        justifyContent = 'flex-start',
        matchContentHeight,
        sideBySideFrom,
        mobileTwoColumnLayout,
    } = state
    const config = useConfig()
    const editorConfig = config.get('editorConfig')
    const resolvedSideBySideFrom = resolveSideBySideFrom({
        sideBySideFrom,
        mobileTwoColumnLayout,
    })

    return (
        <ComponentWrapper
            container={containerSize}
            containerType={containerType}
            isPreviewMode={isPreviewMode}
            aspectRatio={aspectRatio}
            alignContent={alignContent}
            screens={editorConfig?.screens}
        >
            <div
                className={classNames({
                    'container__match-height': matchContentHeight,
                    'container__align-content--top': alignContent === 'flex-start',
                    'container__align-content--center': alignContent === 'center',
                    'container__align-content--end': alignContent === 'flex-end',
                    'container__justify-content--center': justifyContent === 'center',
                    'container__justify-content--end': justifyContent === 'flex-end',
                    'side-by-side-from-mobile':
                        resolvedSideBySideFrom === SIDE_BY_SIDE_FROM.MOBILE,
                    'side-by-side-from-desktop':
                        resolvedSideBySideFrom === SIDE_BY_SIDE_FROM.DESKTOP,
                    'side-by-side-from-always':
                        resolvedSideBySideFrom === SIDE_BY_SIDE_FROM.ALWAYS,
                    // Legacy class kept for any storefront CSS still targeting it
                    'mobile-two-col-layout': resolvedSideBySideFrom === SIDE_BY_SIDE_FROM.ALWAYS,
                })}
            >
                {children}
            </div>
        </ComponentWrapper>
    )
}

export default Component
